import { useEffect } from 'react';
import { usePrevious } from '../usePrevious/usePrevious';
import { useDeepCompareEffectWithInitialRender } from '../useDeepCompareEffect';

export const useEffectWithPrevValue = <T>(value: T, func: (prevValue?: T) => void) => {
  const previous = usePrevious(value);
  useEffect(() => {
    func(previous);
  }, [value]);
};

export const useDeepCompareEffectWithPrevValue = <T>(value: T, func: (prevValue?: T) => void) => {
  const previous = usePrevious(value);
  useDeepCompareEffectWithInitialRender(() => {
    func(previous);
  }, [value]);
};
